import { useState } from "react";
import "./app-demo.css";

import SiteCard from "../site-card/site-card"

import appDemoEmptySvg from "../../assets/img/empty.svg"
import vectorRectangle1SrcAppDemo from "../../assets/img/vectors6442.svg"
import vectorRectangle3SrcAppDemo from "../../assets/img/vectors6445.svg"

export default function  AppDemo() {

	const [contentWidth, setcontentWidth] = useState(600);
	const [contentWrapWidth, setcontentWrapWidth] = useState(616);
	const [contentHeight, setcontentHeight] = useState(400);

	const [totalWrapClass, settotalWrapClass] = useState("total-wrap");
	const [contentWrapClass, setcontentWrapClass] = useState("content-wrap");
	const [contentBodyClass, setcontentBodyClass] = useState("content-body");
	const [panelWrapClass, setpanelWrapClass] = useState("panel-wrap");

	document.addEventListener("appDemoService", (e) => {
		if (e.detail.id && e.detail.id === "appDemo") {
			if (e.detail.hasOwnProperty("rows")) {
				settotalWrapClass("total-wrap total-wrap-rows");
				setcontentWrapClass("content-wrap content-wrap-rows");
				setcontentBodyClass("body-wrap body-wrap-rows");
				setpanelWrapClass("panel-wrap panel-wrap-rows");
			} else if (e.detail.hasOwnProperty("cols")) {
				settotalWrapClass("total-wrap total-wrap-cols");
				setcontentWrapClass("content-wrap content-wrap-cols");
				setcontentBodyClass("body-wrap body-wrap-cols");
				setpanelWrapClass("panel-wrap panel-wrap-cols");
			}
			if (e.detail.hasOwnProperty("contentWidth")) {
				setcontentWidth(Number(e.detail.contentWidth));
				setcontentWrapWidth(Number(e.detail.contentWidth)+16);
			}
			if (e.detail.hasOwnProperty("contentHeight")) {
				setcontentHeight(Number(e.detail.contentHeight));
			}
			
		}
	});

	return(<>			<div id="topbar" className="top-bar" >
				<div className="row-col">
					<p className="no-margin"><b>Disposition:</b></p> 
					<div className="control-input">
						<input type="radio" name="disposicion" value="rows" className="no-margin-top" onClick={(e) => rotate(e)} />
						<label>Rows</label>
					</div>
					<div className="control-input">
						<input type="radio" name="disposicion" value="cols" className="no-margin-top" defaultChecked onClick={(e) => rotate(e)} />
						<label>Columns</label>
					</div>
				</div>
				<div className="range">
					<p className="no-margin"><b>Width (px):</b></p> 
					<div className="control-input">
						<input type="range" id="ancho" name="ancho" min="320" max="2000"  className="width-100" defaultValue="400px" onClick={(e) => changeWidth(e)} />
						<span id="ancho-valor">{contentWidth}</span>
					</div>
				</div>

				<div className="range">
					<p className="no-margin"><b>Height (px):</b></p> 
					<div className="control-input">
						<input type="range" id="altura" name="altura" min="120" max="2000" className="width-100" defaultValue="300px" onClick={(e) => changeHeight(e)} />
						<span id="altura-valor">{contentHeight}</span>
					</div>
				</div>
				<div className="range">
					<div className="control-input">
						<input type="checkbox" id="toggleTexts" onClick={(e) => toggleTexts(e)} />
						<label for="toggleImages">Remove Texts</label>
					</div>
				</div>
				<div className="range">
					<div className="control-input">
						<input type="checkbox" id="toggleImages" onClick={(e) => toggleImages(e)} />
						<label for="toggleImages">Remove Images</label>
					</div>
				</div>
			</div>
<div id="totalwrap" className={totalWrapClass}>
	<div id="contentwrap" className={contentWrapClass} style={{width: contentWrapWidth+"px", height: contentHeight+"px"}}>
		<div id="contentbody" className={contentBodyClass} style={{width: contentWidth+"px", height: contentHeight+"px"}}>
			<SiteCard id="site-card" defaultTexts="on" defaultImages="on" />
			<div className="expand-bottom"></div>
		</div>
	</div>

	<div id="panelwrap" className={panelWrapClass}>

		<h1 className="comp-title">site-card</h1>

		<h2 className="comp-subtitle">Text props</h2>

		<div className="all-text-props">
			<p className="p-prop">s22November = "22 November"</p>
			<p className="p-prop">design = "Design"</p>
			<p className="p-prop">top10ProductDesignIdeas = "Top 10 product design ideas"</p>
			<p className="p-prop">vectorRectangle1Src = "../../assets/img/vectors6442.svg"</p>
			<p className="p-prop">vectorRectangle3Src = "../../assets/img/vectors6445.svg"</p>
		</div>

		<h1 className="comp-title">
			<input title="Outline this component" type="checkbox" onClick={(e) => compHighlight(e, "site-card.botones")} /> 
			&nbsp;botones | site-card.botones
		</h1>

		<h2 className="comp-subtitle">Variants</h2>

		<div className="control-block">
			<input type="radio" name="variants-site-card.botones" id="site-card.botones0" onChange={(e) => sendMessage("site-card.botones", "variant","0")}/>
			<label for="site-card.botones0" className="radio-label">Variant 0</label><br />
			<input type="radio" name="variants-site-card.botones" id="site-card.botones1" onChange={(e) => sendMessage("site-card.botones", "variant","1")}/>
			<label for="site-card.botones1" className="radio-label">Variant 1</label><br />
		</div>

		<h2 className="comp-subtitle">Text props</h2>

		<div className="all-text-props">
			<p className="p-prop">button = "Button"</p>
		</div>

		<h1 className="comp-title">
			<input title="Outline this component" type="checkbox" onClick={(e) => compHighlight(e, "site-card.botones_1")} /> 
			&nbsp;botones | site-card.botones_1
		</h1>

		<h2 className="comp-subtitle">Variants</h2>

		<div className="control-block">
			<input type="radio" name="variants-site-card.botones_1" id="site-card.botones_10" onChange={(e) => sendMessage("site-card.botones_1", "variant","0")}/>
			<label for="site-card.botones_10" className="radio-label">Variant 0</label><br />
			<input type="radio" name="variants-site-card.botones_1" id="site-card.botones_11" onChange={(e) => sendMessage("site-card.botones_1", "variant","1")}/>
			<label for="site-card.botones_11" className="radio-label">Variant 1</label><br />
		</div>

		<h2 className="comp-subtitle">Text props</h2>

		<div className="all-text-props">
			<p className="p-prop">button = "Button"</p>
		</div>

		<h1 className="comp-title">
			<input title="Outline this component" type="checkbox" onClick={(e) => compHighlight(e, "site-card.botones_2")} /> 
			&nbsp;botones | site-card.botones_2
		</h1>

		<h2 className="comp-subtitle">Variants</h2>

		<div className="control-block">
			<input type="radio" name="variants-site-card.botones_2" id="site-card.botones_20" onChange={(e) => sendMessage("site-card.botones_2", "variant","0")}/>
			<label for="site-card.botones_20" className="radio-label">Variant 0</label><br />
			<input type="radio" name="variants-site-card.botones_2" id="site-card.botones_21" onChange={(e) => sendMessage("site-card.botones_2", "variant","1")}/>
			<label for="site-card.botones_21" className="radio-label">Variant 1</label><br />
		</div>

		<h2 className="comp-subtitle">Text props</h2>

		<div className="all-text-props">
			<p className="p-prop">button = "Button"</p>
		</div>
		<div className="bottom-div"></div>
	</div>
</div></>
);
}

function sendMessage(id, name, value) {
	let detail = {id:id}; 
	detail[name] = value;
	const event = new CustomEvent("wcfSubcompsService", {detail:detail});
	document.dispatchEvent(event);
}

function compHighlight(e, id) {
	let detail = {id:id}; 
	if (e.target.checked) {
		detail["wcfHighlight"] = "on";
	} else {
		detail["wcfHighlight"] = "off";
	}
	const event = new CustomEvent("wcfSubcompsService", {detail:detail});
	document.dispatchEvent(event);
}

function rotate(e) {
	let detail = {id:"appDemo"}; 
	if (e.target.value == "rows") {
		detail["rows"] = "true";
	} else {
		detail["cols"] = "true";
	}
	const event = new CustomEvent("appDemoService", {detail:detail});
	document.dispatchEvent(event);		
}

function changeWidth(e) {
	let detail = {id:"appDemo"}; 
	detail["contentWidth"] = e.target.value;
	const event = new CustomEvent("appDemoService", {detail:detail});
	document.dispatchEvent(event);		
}

function changeHeight(e) {
	let detail = {id:"appDemo"}; 
	detail["contentHeight"] = e.target.value;
	const event = new CustomEvent("appDemoService", {detail:detail});
	document.dispatchEvent(event);		
}

function toggleTexts(e) {
	let detail;
	let event;
	if (e.target.checked) {
		detail = {id:"site-card"};
		detail["s22November"] = " ";
		detail["design"] = " ";
		detail["top10ProductDesignIdeas"] = " ";
		event = new CustomEvent("wcfSubcompsService", {detail:detail});
		document.dispatchEvent(event);

		detail = {id:"site-card.botones"};
		detail["button"] = " ";
		event = new CustomEvent("wcfSubcompsService", {detail:detail});
		document.dispatchEvent(event);

		detail = {id:"site-card.botones_1"};
		detail["button"] = " ";
		event = new CustomEvent("wcfSubcompsService", {detail:detail});
		document.dispatchEvent(event);

		detail = {id:"site-card.botones_2"};
		detail["button"] = " ";
		event = new CustomEvent("wcfSubcompsService", {detail:detail});
		document.dispatchEvent(event);

	} else {
		detail = {id:"site-card"};
		detail["s22November"] = "22 November";
		detail["design"] = "Design";
		detail["top10ProductDesignIdeas"] = "Top 10 product design ideas";
		event = new CustomEvent("wcfSubcompsService", {detail:detail});
		document.dispatchEvent(event);

		detail = {id:"site-card.botones"};
		detail["button"] = "Button";
		event = new CustomEvent("wcfSubcompsService", {detail:detail});
		document.dispatchEvent(event);

		detail = {id:"site-card.botones_1"};
		detail["button"] = "Button";
		event = new CustomEvent("wcfSubcompsService", {detail:detail});
		document.dispatchEvent(event);

		detail = {id:"site-card.botones_2"};
		detail["button"] = "Button";
		event = new CustomEvent("wcfSubcompsService", {detail:detail});
		document.dispatchEvent(event);

	}

}

function toggleImages(e) {
	let detail;
	let event;
	if (e.target.checked) {
		detail = {id:"site-card"};
		detail["vectorRectangle1Src"] = appDemoEmptySvg;
		detail["vectorRectangle3Src"] = appDemoEmptySvg;
		event = new CustomEvent("wcfSubcompsService", {detail:detail});
		document.dispatchEvent(event);

	} else {
		detail = {id:"site-card"};
		detail["vectorRectangle1Src"] = vectorRectangle1SrcAppDemo;
		detail["vectorRectangle3Src"] = vectorRectangle3SrcAppDemo;
		event = new CustomEvent("wcfSubcompsService", {detail:detail});
		document.dispatchEvent(event);

	}

}

